import React, { useEffect } from 'react';
import { getDataWithComp, parseCurrency, useEscapeClose } from '../../../utils/SamuiUtils';

const PrintInvoiceModal = ({
    showOptionInvModal,
    setShowOptionInvModal,
    onHandleInvoice1,
    onHandleInvoice2,
    onHandleInvoice3,
    invNo
}) => {
    // ตัวแปรสำหรับใช้เช็กชื่อปุ่ม
    const [docStatusPaid, setDocStatusPaid] = React.useState(null);
    const [docStatusPaidType, setDocStatusPaidType] = React.useState(null);
    const [isVatChecked, setIsVatChecked] = React.useState(false);

    useEscapeClose(showOptionInvModal, () => setShowOptionInvModal(false));

    useEffect(() => {
        const fetchData = async () => {
            // ค้นหาใบกำกับภาษีนั้น เพื่อเอามาใช้ในการเช็กชื่อปุ่ม
            if (showOptionInvModal) {
                const getInvData = await getDataWithComp(
                    'INV_H',
                    `AND Doc_No = '${invNo}'`
                );
                if (getInvData && getInvData.length > 0) {
                    setDocStatusPaid(parseCurrency(getInvData[0].Doc_Status_Paid));
                    setDocStatusPaidType(parseCurrency(getInvData[0].Doc_Status_Paid_Type));
                    setIsVatChecked(parseCurrency(getInvData[0].IsVat) === 1 ? true : false);
                }
            }
        }

        fetchData();
    }, [showOptionInvModal]);

    if (!showOptionInvModal) return null;

    return (
        <div
            className="modal"
            style={{
                display: 'block',
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                zIndex: 1050,
            }}
        >
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content" style={{ borderRadius: '10px' }}>
                    <div className="modal-header" style={{ borderBottom: 'none' }}>
                        <h5 className="modal-title">เลือกประเภทใบกำกับภาษี</h5>
                        <button
                            type="button"
                            className="close"
                            onClick={() => setShowOptionInvModal(false)}
                            style={{ color: '#FF6F00' }}
                        >
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body text-center" style={{ paddingBottom: '100px' }}>
                        {/* {localStorage.getItem("company") === "1" ? (
                            <div style={{ marginBottom: '20px' }}>
                                {docStatusPaidType === 4 ? (
                                    isVatChecked ? (
                                        <>
                                            {docStatusPaid === 3 && (
                                                <button
                                                    onClick={() => {
                                                        onHandleInvoice1();
                                                        setShowOptionInvModal(false);
                                                    }}
                                                    className="btn btn-lg"
                                                    style={{
                                                        fontSize: '18px',
                                                        color: 'white',
                                                        marginRight: '30px',
                                                        backgroundColor: 'purple',
                                                        width: '40%'
                                                    }}
                                                >
                                                    พิมพ์ใบเสร็จรับเงิน/ใบกำกับภาษี
                                                </button>
                                            )}
                                            <button
                                                onClick={() => {
                                                    onHandleInvoice2();
                                                    setShowOptionInvModal(false);
                                                }}
                                                className="btn btn-lg"
                                                style={{
                                                    fontSize: '18px',
                                                    color: 'white',
                                                    marginRight: '30px',
                                                    backgroundColor: 'purple',
                                                    width: '40%'
                                                }}
                                            >
                                                พิมพ์ใบส่งของ/ใบแจ้งหนี้
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            {docStatusPaid === 3 && (
                                                <button
                                                    onClick={() => {
                                                        onHandleInvoice1();
                                                        setShowOptionInvModal(false);
                                                    }}
                                                    className="btn btn-lg"
                                                    style={{
                                                        fontSize: '18px',
                                                        color: 'white',
                                                        marginRight: '30px',
                                                        backgroundColor: 'purple',
                                                        width: '40%'
                                                    }}
                                                >
                                                    พิมพ์ใบเสร็จรับเงิน
                                                </button>
                                            )}
                                            <button
                                                onClick={() => {
                                                    onHandleInvoice2();
                                                    setShowOptionInvModal(false);
                                                }}
                                                className="btn btn-lg"
                                                style={{
                                                    fontSize: '18px',
                                                    color: 'white',
                                                    marginRight: '30px',
                                                    backgroundColor: 'purple',
                                                    width: '40%'
                                                }}
                                            >
                                                พิมพ์ใบส่งของ/ใบแจ้งหนี้
                                            </button>
                                        </>
                                    )
                                ) : (
                                    isVatChecked ? (
                                        <button
                                            onClick={() => {
                                                onHandleInvoice2();
                                                setShowOptionInvModal(false);
                                            }}
                                            className="btn btn-lg"
                                            style={{
                                                fontSize: '18px',
                                                color: 'white',
                                                marginRight: '30px',
                                                backgroundColor: 'purple',
                                                width: '40%'
                                            }}
                                        >
                                            พิมพ์ใบส่งของ/ใบกำกับภาษี
                                        </button>
                                    ) : (
                                        <>

                                            {localStorage.getItem('company') === '1'
                                                && window.location.pathname === '/bill' ? (
                                                <button
                                                    onClick={() => {
                                                        onHandleInvoice3();
                                                        setShowOptionInvModal(false);
                                                    }}
                                                    className="btn btn-lg"
                                                    style={{
                                                        fontSize: '18px',
                                                        color: 'white',
                                                        marginRight: '30px',
                                                        backgroundColor: 'purple',
                                                        width: '40%'
                                                    }}
                                                >
                                                    ใบเสร็จรับเงิน
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => {
                                                        onHandleInvoice1();
                                                        setShowOptionInvModal(false);
                                                    }}
                                                    className="btn btn-lg"
                                                    style={{
                                                        fontSize: '18px',
                                                        color: 'white',
                                                        marginRight: '30px',
                                                        backgroundColor: 'purple',
                                                        width: '40%'
                                                    }}
                                                >
                                                    พิมพ์ใบส่งของ / ใบเสร็จรับเงิน
                                                </button>
                                            )}
                                        </>
                                    )
                                )}
                            </div>
                        ) : (
                            <div style={{ marginBottom: '20px' }}>
                                <button
                                    onClick={() => {
                                        onHandleInvoice1();
                                        setShowOptionInvModal(false);
                                    }}
                                    className="btn btn-lg"
                                    style={{
                                        fontSize: '18px',
                                        color: 'white',
                                        marginRight: '30px',
                                        backgroundColor: 'purple',
                                        width: '40%'
                                    }}
                                >
                                    พิมพ์ใบกำกับภาษี (ต้นฉบับ)
                                </button>
                                <button
                                    onClick={() => {
                                        onHandleInvoice2();
                                        setShowOptionInvModal(false);
                                    }}
                                    className="btn btn-lg"
                                    style={{
                                        fontSize: '18px',
                                        color: 'white',
                                        backgroundColor: 'purple',
                                        width: '40%'
                                    }}
                                >
                                    พิมพ์ใบกำกับภาษี (สำเนา)
                                </button>
                            </div>
                        )} */}
                        <div style={{ marginBottom: '20px' }}>
                            {docStatusPaidType === 4 ? (
                                isVatChecked ? (
                                    <>
                                        {docStatusPaid === 3 && (
                                            <button
                                                onClick={() => {
                                                    onHandleInvoice1();
                                                    setShowOptionInvModal(false);
                                                }}
                                                className="btn btn-lg"
                                                style={{
                                                    fontSize: '18px',
                                                    color: 'white',
                                                    marginRight: '30px',
                                                    backgroundColor: 'purple',
                                                    width: '40%'
                                                }}
                                            >
                                                พิมพ์ใบเสร็จรับเงิน/ใบกำกับภาษี
                                            </button>
                                        )}
                                        <button
                                            onClick={() => {
                                                onHandleInvoice2();
                                                setShowOptionInvModal(false);
                                            }}
                                            className="btn btn-lg"
                                            style={{
                                                fontSize: '18px',
                                                color: 'white',
                                                marginRight: '30px',
                                                backgroundColor: 'purple',
                                                width: '40%'
                                            }}
                                        >
                                            พิมพ์ใบส่งของ/ใบแจ้งหนี้
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        {docStatusPaid === 3 && (
                                            <button
                                                onClick={() => {
                                                    onHandleInvoice1();
                                                    setShowOptionInvModal(false);
                                                }}
                                                className="btn btn-lg"
                                                style={{
                                                    fontSize: '18px',
                                                    color: 'white',
                                                    marginRight: '30px',
                                                    backgroundColor: 'purple',
                                                    width: '40%'
                                                }}
                                            >
                                                พิมพ์ใบเสร็จรับเงิน
                                            </button>
                                        )}
                                        <button
                                            onClick={() => {
                                                onHandleInvoice2();
                                                setShowOptionInvModal(false);
                                            }}
                                            className="btn btn-lg"
                                            style={{
                                                fontSize: '18px',
                                                color: 'white',
                                                marginRight: '30px',
                                                backgroundColor: 'purple',
                                                width: '40%'
                                            }}
                                        >
                                            พิมพ์ใบส่งของ/ใบแจ้งหนี้
                                        </button>
                                    </>
                                )
                            ) : (
                                isVatChecked ? (
                                    <button
                                        onClick={() => {
                                            onHandleInvoice2();
                                            setShowOptionInvModal(false);
                                        }}
                                        className="btn btn-lg"
                                        style={{
                                            fontSize: '18px',
                                            color: 'white',
                                            marginRight: '30px',
                                            backgroundColor: 'purple',
                                            width: '40%'
                                        }}
                                    >
                                        พิมพ์ใบส่งของ/ใบกำกับภาษี
                                    </button>
                                ) : (
                                    <>

                                        {window.location.pathname === '/bill' ? (
                                            <button
                                                onClick={() => {
                                                    onHandleInvoice3();
                                                    setShowOptionInvModal(false);
                                                }}
                                                className="btn btn-lg"
                                                style={{
                                                    fontSize: '18px',
                                                    color: 'white',
                                                    marginRight: '30px',
                                                    backgroundColor: 'purple',
                                                    width: '40%'
                                                }}
                                            >
                                                ใบเสร็จรับเงิน
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => {
                                                    onHandleInvoice1();
                                                    setShowOptionInvModal(false);
                                                }}
                                                className="btn btn-lg"
                                                style={{
                                                    fontSize: '18px',
                                                    color: 'white',
                                                    marginRight: '30px',
                                                    backgroundColor: 'purple',
                                                    width: '40%'
                                                }}
                                            >
                                                พิมพ์ใบส่งของ / ใบเสร็จรับเงิน
                                            </button>
                                        )}
                                    </>
                                )
                            )}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                            <img
                                src="https://www.invoiceberry.com/img/homepage/free_invoice_templates/new/sub_pages/word/screenshot_invoiceberry_invoice_template_2.png"
                                alt="Invoice Example 1"
                                style={{
                                    maxWidth: '20%',
                                    height: 'auto',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrintInvoiceModal;